// Functions
import React, { useState } from "react";
import { Auth, Hub } from "aws-amplify";
import { withRouter } from "react-router-dom";
import { AppContext } from "../Libs/contextLib";
import { FeatureProvider } from "../Libs/FeatureFlag";
// Components
import { Header } from "./Header";
import Routes from "./Routes";
import Box from "@mui/material/Box";

const App = (props) => {
  // App State
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [currUser, setCurrUser] = useState(null);

  const appProps = {
    isAuthenticated,
    isAuthenticating,
    currUser,
  };

  React.useEffect(() => {
    onLoad();
  }, []);

  Hub.listen("auth", ({ payload: { event } }) => {
    switch (event) {
      case "signIn":
        getUser();
        break;
      case "signOut":
        setCurrUser(null);
        break;
      case "cognitoHostedUI_failure":
        break;
      default:
    }
  });

  const onLoad = async () => {
    try {
      await getUser();
      const path = getPathAddress();
      redirect(path);
    } catch (e) {
      if (e === "not authenticated" || e === "The user is not authenticated") {
        if (!props.history.location.search.includes("?code=")) {
          setPathAddress(props.history.location.pathname);
          Auth.federatedSignIn({ provider: "GAS" });
        }
      } else {
        console.log(e);
        setIsAuthenticating(false);
      }
    }
  };

  const setPathAddress = (path) => {
    localStorage.setItem("path", path);
  };

  const getPathAddress = () => {
    return localStorage.getItem("path");
  };

  const redirect = (path) => {
    if (!path) return;
    localStorage.removeItem("path");
    props.history.push(path);
  };

  const getUser = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      setCurrUser(user);
      userHasAuthenticated(true);
      setIsAuthenticating(false);
    } catch (e) {
      throw e;
    }
  };

  return (
    !isAuthenticating && (
      <FeatureProvider>
        <AppContext.Provider value={{ isAuthenticated, currUser }}>
          <Box
            sx={{ display: "flex", flexDirection: "column", height: "100vh" }}
          >
            <Header />
            <Routes appProps={appProps} />
          </Box>
        </AppContext.Provider>
      </FeatureProvider>
    )
  );
};

export default withRouter(App);
